module.exports = __webpack_public_path__ + "img/goldregen-2020-086.0333c4b6.jpg";